import { useIntl } from "react-intl";

const AdminKey = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.AdminKey.header",
            defaultMessage: "Admin key"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.AdminKey.content",
            defaultMessage:
                "Admin key lets site admins diagnose problems faster with temporary access to restricted pages. Page authors receive an email when a site admin has used admin key to view or make changes to their page."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.AdminKey.altText",
            defaultMessage:
                "Example of banner alert that admins see when using admin key"
        }),
        caption: intl.formatMessage({
            id: "ConfluencePricingPage.features.AdminKey.caption",
            defaultMessage:
                "Here’s what an admin sees when using admin key in Confluence."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/admin-key.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.caption}</p>
        </>
    );
};

export default AdminKey;
